import React, { useMemo } from 'react';
import { SignupFormikContext } from '@jetshop/core/components/Auth/signup-context';
import get from 'lodash.get';
export default function useSignupForm() {
    const { formik } = React.useContext(SignupFormikContext);
    const globalError = get(formik, 'status.globalError');
    return useMemo(() => ({
        globalError,
        isSubmitting: formik.isSubmitting,
        handleSubmit: formik.handleSubmit
    }), [formik.handleSubmit, formik.isSubmitting, globalError]);
}
//# sourceMappingURL=useSignupForm.js.map